import { render } from "./WarnIcon.vue?vue&type=template&id=1a0a064a&bindings={}"
import script from "./WarnIcon.vue?vue&type=script&lang=ts"
export * from "./WarnIcon.vue?vue&type=script&lang=ts"
script.render = render

export default script